import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import NodeWithTranslation from "@/view/TiptapArticleBody/components/NodeWithTranslation";
import { ComponentPropsWithIdentifier } from "@/view/TiptapArticleBody/TiptapArticleBody.interface";

export interface QuoteBlockOptions {
  disableTranslation?: boolean;
}

export const QuoteComponent = ({
  editor,
  node,
  extension,
}: ComponentPropsWithIdentifier<QuoteBlockOptions>) => {
  const identifier = `${node.attrs["data-identifier"] || ""}`;
  const { disableTranslation = false } = extension?.options;

  node.identifier = identifier;

  return (
    <NodeWithTranslation
      state={editor.state}
      node={node}
      props={{ "data-identifier": identifier }}
      wrapperProps={{ "data-identifier": identifier, as: "blockquote" }}
      disableTranslation={disableTranslation}
    />
  );
};

export const QuoteBlock = Node.create<QuoteBlockOptions>({
  name: "quote_block",
  content: "text*",
  group: "inline",
  inline: true,
  addAttributes() {
    return {
      "data-identifier": {
        default: null,
      },
    };
  },
  addOptions() {
    return {
      disableTranslation: false,
    };
  },
  renderHTML() {
    return ["blockquote", 0];
  },
  addNodeView() {
    return ReactNodeViewRenderer(QuoteComponent, { contentDOMElementTag: "p" });
  },
});
